/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import DocumentChangeStatusComponent from './document.status.component';
import * as actions from '../../actions/document.status.actions';
import { hideModal, showModal } from '../../actions/actions';
import { MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT } from '../../constants/modalTypes';
import { CHANGE_DOCUMENT_STATUS_COMPLETE_SOP_OPT_INOUT, VERSION } from '../../const';
import { clearConsentDocumentsForSoP } from '../../actions/document.status.optinoptout.actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    consentingGid: ownProps.props.consentingGid,
    consentGid: ownProps.props.consentGid,
    error: state.documentStatus.error,
    documentStatuses: state.documentStatus.documentStatuses,
    isLoading: state.documentStatus.isLoading,
    currentStatus: ownProps.props.currentStatus,
    studyGid: state.subject.participantJourney.studyGid,
    participantId: state.subject.participantJourney.userId,
    participantJourneyGid: state.subject.participantJourney.gid
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    loadDocumentStatuses: (consentingGid) => {
      dispatch(actions.loadDocumentStatuses(consentingGid));
    },
    saveStatus: (formData, isProtected, participantJourneyGid) => {
      dispatch(actions.saveStatus(formData, isProtected));
    },
    hide: () => {
      dispatch(hideModal());
      dispatch(clearConsentDocumentsForSoP());
    },
    goToSoPOptInOptOutStep: (props) => {
      const { consentName, consentVersion } = props;

      dispatch(
        showModal(MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_DOCUMENT_STATUS_COMPLETE_SOP_OPT_INOUT,
          details: [consentName, '-', VERSION, consentVersion].join(' '),
          className: 'document-status-optinoptout-modal',
          props: props
        })
      );
    }
  };
};

const CDocumentChangeStatus = connect(mapStateToProps, mapDispatchToProps)(DocumentChangeStatusComponent);

export default CDocumentChangeStatus;
